/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {DataFieldValueModel, LoadDataFormPayload} from './dataForm.model';

export class LoadDataFormList {
    static readonly type = '[DataForm] Load DataForm list';
}

export class ClearDataFormList {
    static readonly type = '[DataForm] Clear DataForm list';
}

export class LoadDataForm {
    static readonly type = '[DataForm] Load DataForm';

    constructor(public payload: LoadDataFormPayload) {}
}

export class UpdateFormFieldValue {
    static readonly type = '[DataForm] Update form field value';

    constructor(public payload: {formName: string, data: DataFieldValueModel}) {}
}

export class PrefillFormFields {
    static readonly type = '[DataForm] Prefill form field values';

    constructor(public payload: {formName: string, data: DataFieldValueModel[]}) {}
}

